export default "__VITE_ASSET__2GpNmjry__"